import { z } from "zod";

export const ApiTeamSchema = z.object({
  id: z.string().min(1),
  name: z.string().trim().min(1),
  avatarUrl: z.string().min(1).optional(),
  seed: z.number().int().optional(),
  rating: z.number().optional(),
});

export const ApiMatchSchema = z.object({
  id: z.string().min(1),
  name: z.string().optional(),
  matchNumber: z.number().int().optional(),
  roundIndex: z.number().int().optional(),
  bracket: z.enum(["winners", "losers", "finals"]).optional(),
  bestOf: z.union([z.literal(1), z.literal(3), z.literal(5)]).optional(),
  teamAId: z.string().min(1).optional(),
  teamBId: z.string().min(1).optional(),
  scoreA: z.number().int().nonnegative().optional(),
  scoreB: z.number().int().nonnegative().optional(),
  nextMatchIds: z.array(z.string().min(1)).optional(),
  status: z.string().optional(),
  phase: z.string().optional(),
  tournamentCode: z.string().optional(),
  updatedAt: z.string().optional(),
  startByDeadlineUtc: z.string().nullable().optional(),
  isTechnicalWin: z.boolean().optional(),
  hasStats: z.boolean().optional(),
  pausesAllowedPerMatch: z.number().int().nonnegative().optional(),
  team1PausesUsed: z.number().int().nonnegative().optional(),
  team2PausesUsed: z.number().int().nonnegative().optional(),
  team1PausesRemaining: z.number().int().nonnegative().optional(),
  team2PausesRemaining: z.number().int().nonnegative().optional(),
  pausedByTeamId: z.string().nullable().optional(),
  pendingResult: z
    .object({
      winnerId: z.string().nullable().optional(),
      team1Score: z.number().nullable().optional(),
      team2Score: z.number().nullable().optional(),
      byUserId: z.string().nullable().optional(),
      byTeamId: z.string().nullable().optional(),
      atUtc: z.string().nullable().optional(),
    })
    .nullable()
    .optional(),
  preDraftRoomId: z.string().nullable().optional(),
  preDraftBlueLink: z.string().nullable().optional(),
  preDraftRedLink: z.string().nullable().optional(),
  preDraftSpectatorLink: z.string().nullable().optional(),
});

export const ApiBracketSchema = z.object({
  id: z.string().min(1),
  format: z
    .enum(["single_elimination", "double_elimination", "swiss", "round_robin"]),
  status: z.string().optional(),
  teams: z.array(ApiTeamSchema),
  matches: z.array(ApiMatchSchema),
  seedOrder: z.array(z.string().min(1)).optional(),
  matchStartDeadlineEnabled: z.boolean().optional(),
  pausesAllowedPerMatch: z.number().int().nonnegative().optional(),
  pauseDurationMinutes: z.number().int().nonnegative().optional(),
});

export type ApiBracketParsed = z.infer<typeof ApiBracketSchema>;
